module.exports = __webpack_public_path__ + "img/refer_join.2326356a.svg";